import React, { lazy } from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';
// Imported from the module, not the `features/auth` barrel: the barrel re-exports
// a `.jsx` file, which jest's transform does not cover.
import { ProtectedRoute } from '../auth/components/ProtectedRoute';
import { RequireActiveAccount } from '../../router/guards';
import { featureFlags } from '../../config/featureFlags';
import { OBSERVABILITY_PERMISSIONS } from './permissions';
import { OBSERVABILITY_ROUTE_SEGMENT } from './constants';

// Pointing at the page module instead of the feature barrel: importing this file
// from AppRouter must not pull the whole feature into the main bundle. The app's
// global <Suspense fallback={<RouteSkeleton />}> covers it.
const ObservabilityPage = lazy(() =>
  import('./pages/ObservabilityPage').then((module) => ({ default: module.ObservabilityPage })),
);

/**
 * Gated behind REACT_APP_FEATURE_OBSERVABILITY. Non-negotiable while the log reads
 * a mock (see services/observabilityService.ts): the module must never show made-up
 * runs to a customer.
 */
const ObservabilitySectionGate: React.FC = () => {
  if (!featureFlags.observability) return <Navigate to=".." replace />;
  return (
    <ProtectedRoute requiredPermission={OBSERVABILITY_PERMISSIONS.view}>
      <RequireActiveAccount>
        <Outlet />
      </RequireActiveAccount>
    </ProtectedRoute>
  );
};

/**
 * Route subtree of the Observability module, mounted by AppRouter under an agent
 * (`accounts/:accountId/assistants/:AssistantID`).
 *
 * A `Route` element and not a component: `<Routes>` only accepts `Route` children,
 * and a wrapper component would break routing silently. A run opens in its own
 * row (AGE-359 / AGE-360), not on a route of its own, so the subtree has no detail
 * leaf; `viewDetail` gates the row.
 */
export const observabilityRoutes = (
  <Route path={OBSERVABILITY_ROUTE_SEGMENT} element={<ObservabilitySectionGate />}>
    <Route index element={<ObservabilityPage />} />
  </Route>
);
